export const ROUTE_PATH = '/products/:productId';
